/**
 * Logs scene slice
 *
 * @author Manuel Gil <mgil@ubiwhere.com>
 *
 */
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingModule: true
}

export default createSlice({
  name: 'Enroll',
  initialState,
  reducers: {
    onMount: () => {},
    onUnmount: () => {},
    setLoadingModule: (state, action: PayloadAction<boolean>) => {
      state.loadingModule = action.payload;
    },
  }
})